import React from 'react';
import {FormattedDate} from 'react-intl';

const PageHeader = ({dashboard, dates, organization}) => (
    <div>
        <div className="d-flex">
            <div className="flex-fill">
                <h3 className="mb-0">{dashboard.name}</h3>
                <FormattedDate value={dates.from} /> - <FormattedDate value={dates.to} />
            </div>
            <div>
                {organization.branding.logo && <img className="org-logo" src={organization.branding.logo} /> || organization.name}
            </div>
        </div>
        <hr />
    </div>
);

export default PageHeader;
